import {congrats} from "../data/congrats";
import WheelFortune from "./wheel-fortune.js";

export default class Filter {
  constructor(siteBodyElement) {
    this._buttonFilterSelected = siteBodyElement.querySelector(`.page__filter-selected`);
    this._filterSelect = siteBodyElement.querySelector(`.page__filter-list`);
    this._congratsText = siteBodyElement.querySelector(`.congrats__text`);
		this._spinnerButton = siteBodyElement.querySelector(`.spinner__button`);
    this._openFilter = this._openFilter.bind(this);
    this._closeFilter = this._closeFilter.bind(this);
    this._selectedFilter = this._selectedFilter.bind(this);
    this.wheelForune = new WheelFortune(siteBodyElement);
  }

  init() {
    this._buttonFilterSelected.addEventListener(`click`, this._openFilter);
    this._filterSelect.addEventListener(`click`, this._selectedFilter);
  }

  _openFilter(event) {
    event.preventDefault();
    this._buttonFilterSelected.classList.toggle(`filter_open`);
  }

  _closeFilter() {
    this._buttonFilterSelected.classList.remove(`filter_open`);
  }

  _selectedFilter(event) {
    event.preventDefault();
    ('ga' in window) && ga('send', 'event', 'SpecialProject', '23feb21_select');
    // -> this._congratsText.textContent = congrats[event.target.dataset.filter].text;
		this._buttonFilterSelected.textContent = event.target.textContent;
		this._buttonFilterSelected.classList.add('active')
		this._spinnerButton.classList.add('active')
    this._closeFilter();
    this.wheelForune.state.filterItem = event.target.dataset.filter;


    if (!this.wheelForune.state.wheelButtonActivate) {
      this.wheelForune.init();
    }
  }
}
